<template>
	<article v-if='!vocab'>loading...</article>
	<article v-else @click='next'>
		<section v-if="stage === 'showQuestion'" @click="stage = 'showAnswer'" class='question'>
			{{vocab.lang1}}
		</section>
		<section v-else-if="stage === 'showAnswer'" @click="stage = 'showRating'" class='answer'>
			{{vocab.lang2}}
		</section>
		<template v-else class="rating">
			<button @click="answer(false)" class='rating wrong'>
				<div>: (</div>
			</button>
			<button @click="answer(true)" class='rating right' autofocus>
				<div>: )</div>
			</button>
		</template>
	</article>
</template>

<script>
export default {
	name: 'VocabCard',
	data() {
		return {stage: 'showQuestion'};
	},
	props: {
		vocab: {
			type: Object,
			default: () => ({
				id: '',
				lang1: '',
				lang2: '',
				updatedAt: ''
			})
		}
	},
	methods: {
		answer(wasCorrect) {
			const vocabId = this.vocab.id;
			let historicData = localStorage.getItem(vocabId) ? JSON.parse(localStorage.getItem(vocabId)) : false;

			// console.log(`answer was correct for ${vocabId}: ${wasCorrect}\nhistoric data:`);
			// console.log(historicData);

			if (historicData) {
				historicData.noTotal ++;
				historicData.noWrong += wasCorrect ? 0 : 1;
				historicData.lastQuestioned = new Date();
			}
			else {
				historicData = {
					noTotal: 1,
					noWrong: wasCorrect ? 0 : 1,
					lastQuestioned: new Date()
				};
			}

			localStorage.setItem(vocabId, JSON.stringify(historicData));
			// redirect to next vocab
			this.$router.push({path: `/question`});
		},
		next() {
			if (this.stage === 'showQuestion') {
				this.stage = 'showAnswer';
			}
			else if (this.stage === 'showAnswer') {
				this.stage = 'showRating';
			}
			else {
				this.stage = 'showQuestion';
			}
		}
	}
};
</script>

<style scoped>
article {
	grid-area: main;
	/*margin-left: auto;*/
	/*margin-right: auto;*/
	justify-self: center;
	align-self: center;
	height: 60vh;
	/*
	grid-column-start: 2;
	grid-column-end: 3;
	*/

	/*flex: 1;*/
	display: inline-grid;
	grid-template-columns: 1fr 1fr;
	/*margin: 2rem;*/
	max-height: 50vh;
	font-size: var(--fontx25);
	/*margin-top: auto;*/
	/*margin-bottom: auto;*/
	background-color: white;
	color: var(--blue1);
	justify-content: stretch;
	/*for first line alignment*/
	align-items: center;
	/*for multi-row alignment*/
	text-align: center;
	border-radius: 0.5em;
	cursor: pointer;
}

@media only screen and (max-width: 800px) {
	article {
		width: 80%;
		padding: 0;
	}

	button.rating {
		border-radius: 0.5em;
		height: 100%;
	}
}

@media only screen and (min-width: 800px) {
	article {
		width: calc(50vh * 2);
	}

	button.rating {
		border-radius: 50%;
		height: calc(100% - 2em);
		margin-right: 1em;
		margin-left: 1em;
	}
}

section {
	grid-column-start: 1;
	grid-column-end: 3;
	margin: 0.75em 1.5em;
}

button.rating {
	font-size: var(--font2);
	border-style: none;
	background: white;
	padding: 0;
	cursor: pointer;
	color: var(--blue1);	
}

button.rating:hover {
	background: #2c3e50;
	color: white;
	font-weight: bold;
}

button.rating > div {
	transform: rotate(-270deg);
	font-size: var(--fontx25);
}
</style>


// WEBPACK FOOTER //
// VocabCardQuestion.vue?04c3810c